<script lang="ts" setup>
import useAsset from "@/shared-helpers/useAsset";
import { useRouter } from "vue-router";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { setLanguage } from "@/apps/credit-line/helpers/translations.helper";
import { useCreditLineSummary } from "@/apps/credit-line/hooks/useCreditLineSummary";
import { getCurrentInstance } from "vue";

const { t } = useI18n();
const { fetchSummary } = useCreditLineSummary();

setLanguage(getCurrentInstance()?.proxy);

const router = useRouter();

const onDismiss = () => {
  fetchSummary(true);
  router.push({
    name: "CreditCardDetailsView",
    query: { defaultType: "VIRTUAL" },
  });
};
</script>

<template>
  <div class="container">
    <header class="header">
      <button class="dismiss-button" @click="onDismiss">
        <i class="fa fa-times"></i>
      </button>
    </header>

    <h1 class="title" v-html="t('CL_VIRTUAL_DISCOVERY.TITLE')"></h1>

    <img
      :src="useAsset('img/credit-line/discovery-accent.svg')"
      alt=""
      class="accent-image"
    />

    <ul class="list">
      <li>{{ t("CL_VIRTUAL_DISCOVERY.BULLET_POINT_1") }}</li>
      <li>{{ t("CL_VIRTUAL_DISCOVERY.BULLET_POINT_2") }}</li>
      <li>{{ t("CL_VIRTUAL_DISCOVERY.BULLET_POINT_3") }}</li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.container {
  background: $pj-color-green;
  min-height: 100vh;
}

.header {
  padding: 10px 4px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.dismiss-button {
  background: none;
  border: none;
  padding: 12px;
  height: 60px;
  width: 60px;
  color: white;
  font-size: 30px;
}

.title {
  color: white;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.accent-image {
  width: 100%;
  max-width: 280px;
  display: flex;
  align-self: center;
  min-height: 260px;
}

.list {
  margin-top: 46px;
  color: white;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}

.list li:not(:first-child) {
  margin-top: 16px;
}
</style>
